module.exports = __webpack_public_path__ + "img/3.967513a7.jpg";